import { render, staticRenderFns } from "./HomeWhitelabel.vue?vue&type=template&id=2111cc44&scoped=true"
import script from "./HomeWhitelabel.vue?vue&type=script&lang=js"
export * from "./HomeWhitelabel.vue?vue&type=script&lang=js"
import style0 from "./HomeWhitelabel.vue?vue&type=style&index=0&id=2111cc44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2111cc44",
  null
  
)

export default component.exports